import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'
import parserFilters from '@/utils/parserFilters'
import parserSlug from '@/utils/parserSlug'
import moment from 'moment'

Vue.use(Vuex)

const state = {
  rfis: [],
  projects: [],
  pagination: {
    currentPage: 1,
    perPage: 5,
    totalRfis: 0,
    totalPages: 0
  },
  paginationProjects: {
    currentPage: 1,
    perPage: 5,
    totalProjects: 0,
    totalPages: 0
  },
  rfisCatalog: {
    projects: [],
    customers: []
  },
  filterParams: '',
  filterParamsProject: '',
  isLoading: false,
  isRfis: false,
  idProject: 0,
  isModalVisible: false,
  isChatVisible: false
}

const mutations = {
  SET_LOADING (state, payload) {
    state.isLoading = payload
  },
  SET_RFIS_LIST_VIEW (state, payload) {
    state.isRfis = payload
  },
  SET_PROJECTS (state, payload) {
    state.projects = payload.data.data
    state.paginationProjects = {
      currentPage: payload.data.current_page,
      perPage: payload.data.per_page,
      totalProjects: payload.data.total,
      totalPages: payload.data.last_page
    }
  },
  SET_RFIS (state, payload) {
    state.rfis = payload.data
    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalRfis: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_RFIS_INFINITE_LIST (state, payload) {
    payload.data.forEach(e => {
      state.rfis.push(e)
    })

    state.pagination = {
      currentPage: payload.current_page,
      perPage: payload.per_page,
      totalCustomers: payload.total,
      totalPages: payload.last_page
    }
  },
  SET_PROJECTS_INFINITE_LIST (state, payload) {
    payload.data.data.forEach(e => {
      state.projects.push(e)
    })

    state.paginationProjects = {
      currentPage: payload.data.current_page,
      perPage: payload.data.per_page,
      totalCustomers: payload.data.total,
      totalPages: payload.data.last_page
    }
  },
  ADD_RFI (state, payload) {
    if (state.idProject === payload.project.id) {
      state.rfis.unshift(payload)
    }
    const idx = state.projects.findIndex(u => u.id === payload.project.id)
    if (idx === -1) {
      state.projects.unshift(payload.project)
    }
  },
  UPDATE_RFI (state, payload) {
    const idx = state.rfis.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.set(state.rfis, idx, payload)
    }
  },
  DELETE_RFI (state, payload) {
    const idx = state.rfis.findIndex(u => u.id === payload)
    if (idx >= 0) {
      Vue.delete(state.rfis, idx)
    }
  },
  DELETE_RFIS (state, payload) {
    payload.ids.forEach(id => {
      const idx = state.rfis.findIndex(u => u.id === id)
      if (idx >= 0) {
        Vue.delete(state.rfis, idx)
      }
    })
  },
  CLEAN_RFIS (state, payload) {
    state.rfis = []
    state.project = []
    state.isRfis = false
    state.idProject = 0
    state.pagination = {
      currentPage: 1,
      perPage: 5,
      totalRfis: 0,
      totalPages: 0
    }
  },
  SET_PROJECT_ID (state, payload) {
    state.idProject = payload
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  SET_CHAT_VISIBLE (state, payload) {
    state.isChatVisible = payload
  },
  SET_FILTER_PARAMS (state, payload) {
    state.filterParams = payload
  },
  SET_FILTER_PARAMS_PROJECTS (state, payload) {
    state.filterParamsProject = payload
  },
  SET_CATALOG (state, { object, payload }) {
    state.rfisCatalog[object] = payload.data
  },
  SET_RFIS_CATALOG (state, payload) {
    state.rfisCatalog = { ...state.rfisCatalog, ...payload }
  }
}

const actions = {
  async loadProjects ({ commit }, payload) {
    commit('SET_RFIS_LIST_VIEW', false)
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`projects/rfis?page=${payload.page}${state.filterParamsProject}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADING', false, { root: true })
        commit('SET_PROJECTS', response.data)
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async loadRfis ({ commit }, payload) {
    commit('SET_RFIS_LIST_VIEW', true)
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`rfis?page=${payload.page}${state.filterParams}&project_id=${payload.id}`)
      const checkErrors = checkResponse(response)
      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_LOADING', false, { root: true })
        commit('SET_RFIS', response.data)
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async loadRfisInfiniteList ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`rfis?page=${payload.page}${state.filterParams}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RFIS_INFINITE_LIST', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadProjectsInfiniteList ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`projects/rfis?page=${payload.page}${state.filterParamsProject}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_PROJECTS_INFINITE_LIST', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async addRfi ({ commit }, payload) {
    let formData = new FormData()
    formData.append('rfi_number', payload.rfi_number)
    formData.append('type', parseInt(payload.type))
    formData.append('requested_information', payload.requested_information)
    formData.append('requested_date', moment(payload.requested_date).format('YYYY-MM-DD HH:MM:SS'))
    formData.append('question', payload.question)
    formData.append('pendiente', 1)
    formData.append('is_rfi_question', 1)
    formData.append('customer_id', payload.project.customer_id)
    formData.append('project_id', payload.project.id)
    formData.append('reference', payload.reference)
    if (payload.files) {
      for (let i = 0; i < payload.files.length; i++) {
        formData.append('files[]', payload.files[i])
      }
    }
    commit('SET_LOADING', true, { root: true })

    try {
      const response = await axios.post('rfis', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_RFI', response.data)
        commit('SET_CHAT_VISIBLE', false)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.rfis', text: 'front.added_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async editRfi ({ commit }, payload) {
    let formData = new FormData()
    formData.append('answer', payload.answer)
    formData.append('is_rfi_question', 0)
    formData.append('reply_date', moment(payload.reply_date).format('YYYY-MM-DD HH:MM:SS'))
    if (payload.answerFiles) {
      for (let i = 0; i < payload.answerFiles.length; i++) {
        formData.append('answerFiles[]', payload.answerFiles[i])
      }
    }
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`rfis/${payload.id}/answer`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        commit('SET_LOADING', false, { root: true })
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RFI', response.data)
        commit('SET_LOADING', false, { root: true })
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.rfis', text: 'front.updated_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      commit('SET_LOADING', false, { root: true })
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    }
  },
  async deleteRfi ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`rfis/${payload}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_RFI', payload)
        commit('SET_MODAL_VISIBLE', false)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.rfis', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async deleteRfis ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.delete(`rfis/delete`, { params: { ids: payload.ids } })
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_RFIS', payload)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.rfis', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async actionRfi ({ commit }, payload) {
    try {
      const response = await axios.put(`rfis/${payload.id}/${payload.action}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('UPDATE_RFI', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
    }
  },
  printReport ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(axios.defaults.baseURL + '/rfis/export?' + state.filterParams)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async printRfi ({ commit }, payload) {
    app.$Progress.start()
    try {
      window.open(`${axios.defaults.baseURL}/rfi/${payload}/export`)
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  applyFilter ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS', filter)
  },
  clearFilter ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS', filter)
  },
  applyFilterProjects ({ commit }, payload) {
    const filter = parserFilters(payload)
    commit('SET_FILTER_PARAMS_PROJECTS', filter)
  },
  clearFilterProjects ({ commit }, payload) {
    const filter = ''
    commit('SET_FILTER_PARAMS_PROJECTS', filter)
  },
  setIdProject ({ commit }, payload) {
    commit('SET_PROJECT_ID', payload)
  },
  async loadCatalog ({ commit }, payload) {
    let url = parserSlug(payload.url)
    app.$Progress.start()
    try {
      const response = await axios.get(`${url}${payload.filter}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CATALOG', { object: payload.url, payload: response.data })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  async loadRfisCatalog ({ commit }, payload) {
    app.$Progress.start()
    try {
      const response = await axios.get(`rfis/catalog`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'strings.rfis', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RFIS_CATALOG', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
    }
  },
  cleanRFIS ({ commit }) {
    commit('CLEAN_RFIS')
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  },
  setChatVisible ({ commit }, payload) {
    commit('SET_CHAT_VISIBLE', payload)
  },
  setModalImportVisible ({ commit }, payload) {
    commit('SET_MODAL_IMPORT_VISIBLE', payload, { root: true })
  }
}

const getters = {
  rfis: state => state.rfis,
  projects: state => state.projects,
  rfisCatalog: state => state.rfisCatalog,
  pagination: state => state.pagination,
  paginationProjects: state => state.paginationProjects,
  isModalVisible: state => state.isModalVisible,
  isChatVisible: state => state.isChatVisible,
  filterParams: state => state.filterParams,
  filterParamsProject: state => state.filterParamsProject,
  isLoading: state => state.isLoading,
  isRfis: state => state.isRfis,
  idProject: state => state.idProject
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
